import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  alert: {
    marginTop: '70px',
  },
})

export default useStyles
